<template>
  <a-modal title="审核邮寄申请" :visible="open" @cancel="onClose" @ok="submitForm">
    <a-form-model ref="form" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="审核结果" prop="auditStatus">
        <a-radio-group v-model="form.auditStatus">
          <a-radio :value="1">通过</a-radio>
          <a-radio :value="2">拒绝</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="审核原因" prop="auditReason">
        <a-textarea v-model="form.auditReason" :rows="3" :maxLength="200" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { auditMailApply } from '@/api/cloudplant/mailApply'

export default {
  name: 'AuditForm',
  data() {
    return {
      labelCol: { span: 6 }, wrapperCol: { span: 16 }, open: false,
      form: { id: null, auditStatus: 1, auditReason: null },
      rules: { auditStatus: [{ required: true, message: '请选择审核结果', trigger: 'change' }] }
    }
  },
  methods: {
    onClose() { this.open = false; this.reset() },
    reset() { this.form = { id: null, auditStatus: 1, auditReason: null } },
    show(row) { this.reset(); this.form.id = row.id; this.open = true },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          auditMailApply(this.form).then(() => { this.$message.success('审核成功'); this.open = false; this.$emit('ok') })
        }
      })
    }
  }
}
</script>
